var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiPowered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.89L10.94 10H13.76L11.49 11.62L12.42 14.63L10 12.79L7.58 14.63L8.51 11.62L6.24 10H9.06L10 6.89ZM7.58 8H0L6.17 12.41L3.83 20L10 15.31L16.18 20L13.83 12.41L20 8H12.42L10 0L7.58 8ZM20.36 20L18.5 13.99L22.68 11H19.24L16.16 13.2L17.62 17.92L20.36 20ZM16 6L14.18 0L13.14 3.45L13.91 6H16Z",
    fill: "#336BBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPowered);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTAgNi44OUwxMC45NCAxMEgxMy43NkwxMS40OSAxMS42MkwxMi40MiAxNC42M0wxMCAxMi43OUw3LjU4IDE0LjYzTDguNTEgMTEuNjJMNi4yNCAxMEg5LjA2TDEwIDYuODlaTTcuNTggOEgwTDYuMTcgMTIuNDFMMy44MyAyMEwxMCAxNS4zMUwxNi4xOCAyMEwxMy44MyAxMi40MUwyMCA4SDEyLjQyTDEwIDBMNy41OCA4Wk0yMC4zNiAyMEwxOC41IDEzLjk5TDIyLjY4IDExSDE5LjI0TDE2LjE2IDEzLjJMMTcuNjIgMTcuOTJMMjAuMzYgMjBaTTE2IDZMMTQuMTggMEwxMy4xNCAzLjQ1TDEzLjkxIDZIMTZaIiBmaWxsPSIjMzM2QkJDIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };